// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Variables
     */

    let lastScrollPosition = 0;

    /**
     * Event listener on scroll
     */

    window.addEventListener('scroll', () => {
        scrollDirection();
    });

    /**
     * Event listener on resize
     */

    window.addEventListener('resize', () => {
        scrollDirection();
    });

    /**
     * Scroll direction
     * Up or Down, except top and bottom of the page
     */

    const scrollDirection = () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition < 50 || scrollPosition > document.body.clientHeight - window.innerHeight - 100) {
            document.querySelector('body').classList.add('scroll-direction-up');
            document.querySelector('body').classList.remove('scroll-direction-down');
        } else {
            if (scrollPosition > lastScrollPosition) {
                document.querySelector('body').classList.remove('scroll-direction-up');
                document.querySelector('body').classList.add('scroll-direction-down');
            } else {
                document.querySelector('body').classList.add('scroll-direction-up');
                document.querySelector('body').classList.remove('scroll-direction-down');
            }
        }
        lastScrollPosition = scrollPosition;
    }

});
